import React from 'react';
import AnswerItems from './com.answerItems'
import { connect } from 'react-redux'
import { addAnswer, removeAnswer } from '../../Actions/a.survey'
class AnswersList extends React.Component {

    handleAnswers = (AnswerId, AnswerType, Checked) => {

        if (AnswerType == "0") {//radiobutton

            let item = {
                QuestionId: this.props.Id,
                AnswersType: this.props.Type,
                Answers: [{ Id: AnswerId }]
            };

            this.props.AddAnswer(item);

        }
        else {//checkbox
            console.log(Checked);

            if (Checked) {

                let item = {
                    QuestionId: this.props.Id,
                    AnswersType: this.props.Type,
                    Answers: [{ Id: AnswerId }]
                };

                this.props.AddAnswer(item);
            }
            else {//unchecked

                let item = {
                    QuestionId: this.props.Id,
                    AnswersType: this.props.Type,
                    AnswerId: AnswerId
                };
                this.props.RemoveAnswer(item);
            }

        }
    }
    render() {

        const { Answers } = this.props;
        return (
            <React.Fragment>
                {Answers.map((item) => (
                    <AnswerItems Type={this.props.Type}
                        Text={item.Answer}
                        QuestionId={this.props.Id}
                        key={item.ID}
                        Id={item.ID}
                        HandleAnswers={
                            (AnswerId, AnswerType, Checked) => this.handleAnswers(AnswerId, AnswerType, Checked)} />
                ))}
            </React.Fragment>
        );
    };
}
var mapDispatchToProps = function (dispatch) {
    return {
        AddAnswer: (data) => dispatch(addAnswer(data)),
        RemoveAnswer: (data) => dispatch(removeAnswer(data))

    }
};
const mapStateToProps = function (state) {
    return {

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(AnswersList);


// WEBPACK FOOTER //
// ./src/Components/Requests/com.answersList.jsx